import Color from '@bubble-dev/fantasy-color';
import { createConstantColorDeprecated } from './helpers';
var deprecation = {
  removalDate: 'v5.0.0'
};
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopKlarnaPink = createConstantColorDeprecated('brandLollipopKlarnaPink', deprecation, new Color('#FFB3C7'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopKlarnaBlack = createConstantColorDeprecated('brandLollipopKlarnaBlack', deprecation, new Color('#17120F'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopKlarnaWhite = createConstantColorDeprecated('brandLollipopKlarnaWhite', deprecation, new Color('#FFFFFF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothYellow = createConstantColorDeprecated('brandLollipopSmooothYellow', deprecation, new Color('#FFF673'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothYellowBlocks = createConstantColorDeprecated('brandLollipopSmooothYellowBlocks', deprecation, new Color('#FFF999'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothGreen = createConstantColorDeprecated('brandLollipopSmooothGreen', deprecation, new Color('#80FFA6'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothGreenBlocks = createConstantColorDeprecated('brandLollipopSmooothGreenBlocks', deprecation, new Color('#9EFFBB'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothBlue = createConstantColorDeprecated('brandLollipopSmooothBlue', deprecation, new Color('#73F5FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSmooothBlueBlocks = createConstantColorDeprecated('brandLollipopSmooothBlueBlocks', deprecation, new Color('#99F8FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopVanilla = createConstantColorDeprecated('brandLollipopVanilla', deprecation, new Color('#FFFAB0'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopVanillaLight = createConstantColorDeprecated('brandLollipopVanillaLight', deprecation, new Color('#FFFCC9'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopMint = createConstantColorDeprecated('brandLollipopMint', deprecation, new Color('#B8FFCC'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopMintLight = createConstantColorDeprecated('brandLollipopMintLight', deprecation, new Color('#D1FFE0'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopPool = createConstantColorDeprecated('brandLollipopPool', deprecation, new Color('#B3F9FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopPoolLight = createConstantColorDeprecated('brandLollipopPoolLight', deprecation, new Color('#CCFCFF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopLavender = createConstantColorDeprecated('brandLollipopLavender', deprecation, new Color('#E9D6FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopLavenderLight = createConstantColorDeprecated('brandLollipopLavenderLight', deprecation, new Color('#F0E3FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSky = createConstantColorDeprecated('brandLollipopSky', deprecation, new Color('#BDD5FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopSkyLight = createConstantColorDeprecated('brandLollipopSkyLight', deprecation, new Color('#D1E2FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopPeach = createConstantColorDeprecated('brandLollipopPeach', deprecation, new Color('#FFD7AD'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandLollipopPeachLight = createConstantColorDeprecated('brandLollipopPeachLight', deprecation, new Color('#FFE6CC'));
//# sourceMappingURL=lollipopBrandColors.js.map